import { render, staticRenderFns } from "./ExportDEB.vue?vue&type=template&id=6aa51a70&"
import script from "./ExportDEB.vue?vue&type=script&lang=js&"
export * from "./ExportDEB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports